import { texts } from "@sveabank/cc-common";
import type { ErrorContent } from "../../types/error";

export const errorCodeMap: Record<string, ErrorContent> = {
	FETCH_ERROR: {
		heading: texts.error.modal.networkError.heading,
		body: texts.error.modal.networkError.body,
	},
	CUSTOM_ERROR: {
		heading: texts.error.modal.fallbackTitle,
		body: texts.error.modal.fallbackBody,
	},
	failedAuthSignStatus: {
		heading: texts.error.modal.bankIdCancel.heading,
		body: texts.error.modal.bankIdCancel.body,
	},
	SigningNotInitiallized: {
		heading: texts.error.modal.bankIdCancel.heading,
		body: texts.error.modal.bankIdCancel.body,
	},
	UserCancel: {
		heading: texts.error.modal.bankIdUserCancel.heading,
		body: texts.error.modal.bankIdUserCancel.body,
	},
	ExpiredTransaction: {
		heading: texts.error.modal.bankIdTimeout.heading,
		body: texts.error.modal.bankIdTimeout.body,
	},
	Cancelled: {
		heading: texts.error.modal.bankIdCancel.heading,
		body: texts.error.modal.bankIdCancel.body,
	},
	StartFailed: {
		heading: texts.error.modal.bankIdTimeout.heading,
		body: texts.error.modal.bankIdTimeout.body,
	},
	MissingBeneficialOwners: {
		heading: texts.error.modal.missingBeneficialOwner.title,
		body: texts.error.modal.missingBeneficialOwner.body,
	},
};

export const statusCodeMap: Record<number, ErrorContent> = {
	401: {
		heading: texts.error.modal.loggedOut.heading,
		body: texts.error.modal.loggedOut.body,
	},
};

export const defaultErrorContent: ErrorContent = {
	heading: texts.error.modal.fallbackTitle,
	body: texts.error.modal.fallbackBody,
};
